import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ProductProvider } from './context/ProductsContext';
import { HeaderProvider } from './context/HeaderContext';
import { OrderProvider } from './context/OrderContext';
import { CartProvider } from 'react-use-cart';

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <React.StrictMode>
    <CartProvider>
      <HeaderProvider>
        <ProductProvider>
          <OrderProvider>
            <App />
          </OrderProvider>
        </ProductProvider>
      </HeaderProvider>
    </CartProvider>
  </React.StrictMode>
);